import React from "react"
import { navigate } from "gatsby"
import { connect } from "react-redux"
import { previousStep } from "../../state/actions/questionnaire"
import { QuestionnaireBackButton } from "@thedgbrt/logology-ui-components"

const BackButton = ({ basepath, step, invisible }) => {
  if (invisible)
    return (
      <span style={{ visibility: "hidden" }}>
        <QuestionnaireBackButton />
      </span>
    )

  return (
    <QuestionnaireBackButton
      handleClick={() => {
        previousStep()
        navigate(`${basepath}${step - 1}`)
      }}
    />
  )
}

export default connect(
  null,
  { previousStep }
)(BackButton)
